var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38043",
    "data-name": "Group 38043",
    transform: "translate(540 -1761)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14656",
    "data-name": "Rectangle 14656",
    width: 12,
    height: 12,
    transform: "translate(-540 1761)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_19",
    "data-name": 19,
    transform: "translate(-539.249 1761.749)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33392",
    "data-name": "Path 33392",
    d: "M11.749,15.515a.75.75,0,0,1-.532-1.282l3.975-3.967L11.216,6.3A.75.75,0,0,1,12.274,5.24l4.5,4.5a.75.75,0,0,1,0,1.058l-4.5,4.5a.75.75,0,0,1-.525.218Z",
    transform: "translate(-6.494 -5.012)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33393",
    "data-name": "Path 33393",
    d: "M5.749,15.5a.75.75,0,0,1-.533-1.282l3.975-3.967L5.216,6.281A.753.753,0,0,1,6.281,5.216l4.5,4.5a.75.75,0,0,1,0,1.057l-4.5,4.5A.75.75,0,0,1,5.749,15.5Z",
    transform: "translate(-4.994 -4.996)",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrowRight);
export default __webpack_public_path__ + "static/media/double-arrow-right.91e9b5ec803d39109a2cfa6a8b032261.svg";
export { ForwardRef as ReactComponent };